import axios from "axios";
import { productSearchApiUrl, productSearchWithAkaNameApiUrl, staffUsersSearchApi, userSearchApiUrl } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const searchUser = async (name) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(
        userSearchApiUrl + "?search=" + name,
        config,
    );

    return response;
};

export const searchProduct = async (name) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(
        productSearchApiUrl + name,
        config,
    );

    return response;
};

export const searchProductWithAkaName = async (name) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(
        productSearchWithAkaNameApiUrl + name,
        config,
    );

    return response;
};

export const searchStaffUsers = async ({ query = "" } = {}) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(
        staffUsersSearchApi + query,
        config,
    );

    return response;
};
